import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import CPSSettlementReservationSummary from '../../components/admin/cps/CPSSettlementReservationSummary';
import RejectedResultsSummary from '../../components/admin/result/RejectedResultsSummary';
import ProjectCompletionSummary from '../../components/admin/project/ProjectCompletionSummary';
import OngoingProjectSummary from '../../components/admin/project/OngoingProjectSummary';
import CompletedProjectSummary from '../../components/admin/project/CompletedProjectSummary';
import '../../styles/pages/AdminPages.css';

function ProjectPage() {
  const navigate = useNavigate();

  return (
    <AdminLayout title="프로젝트 관리">

      <div className="admin-page__dashboard">
        {/* 구매당 리워드 결산 미진행건 처리 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">CPS 정산 대기</h2>
          <CPSSettlementReservationSummary interactive={false} />
          <div className="admin-page__section-action">
            <button 
              className="admin-page__action-button"
              type="button" 
              onClick={() => navigate('/admin/project/cps-settlement-pending')}
            >
              관리
            </button>
          </div>
        </div>

        {/* 결과물 거절 건 처리 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">결과물 거절 건</h2>
          <RejectedResultsSummary interactive={false} />
          <div className="admin-page__section-action">
            <button 
              className="admin-page__action-button"
              type="button" 
              onClick={() => navigate('/admin/project/rejected-results')}
            >
              관리
            </button>
          </div>
        </div>

        {/* 프로젝트 완료 처리 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">프로젝트 완료 대기</h2>
          <ProjectCompletionSummary interactive={false} />
          <div className="admin-page__section-action">
            <button 
              className="admin-page__action-button"
              type="button" 
              onClick={() => navigate('/admin/project/completion')}
            >
              관리
            </button>
          </div>
        </div>

        {/* 진행중인 프로젝트 보기 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">진행 중 프로젝트</h2>
          <OngoingProjectSummary interactive={false} />
          <div className="admin-page__section-action">
            <button 
              className="admin-page__action-button"
              type="button" 
              onClick={() => navigate('/admin/project/ongoing')}
            >
              관리
            </button>
          </div>
        </div>

        {/* 완료된 프로젝트 보기 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">완료된 프로젝트</h2>
          <CompletedProjectSummary interactive={false} />
          <div className="admin-page__section-action">
            <button 
              className="admin-page__action-button"
              type="button" 
              onClick={() => navigate('/admin/project/completed')}
            >
              관리
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default ProjectPage;
